/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import React from 'react';
import Media from 'react-media';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { ScreenBreakpoints } from 'app/gamma/src/components/responsive';
import {
  State,
  toggleBoardsMenu,
  setBoardsMenuHeaderButtonMouseOver,
} from 'app/gamma/src/modules';
import { getBoardsMenu } from 'app/gamma/src/selectors/boards';
import { areAnyPopoversOrOverlaysCurrentlyOpen } from 'app/gamma/src/selectors/popovers';
import { forTemplate } from 'app/common/lib/util/i18n';

import HeaderButton from './button';
import styles from './header.less';

interface StateProps {
  activeOverlays: boolean;
  isBoardsMenuOpen: boolean;
}

interface DispatchProps {
  toggleMenu(): void;
  setMouseTarget(): void;
  unsetMouseTarget(): void;
}

interface AllProps extends StateProps, DispatchProps {}

const format = forTemplate('boards_sidebar');

class HeaderBoardMenuButton extends React.Component<AllProps> {
  onHeaderButtonClick = () => {
    const { isBoardsMenuOpen, toggleMenu } = this.props;

    if (!isBoardsMenuOpen) {
      toggleMenu();

      trackUe({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.BOARDS_MENU,
        method: 'by clicking boards button in header',
      });
    }
  };

  render() {
    return (
      <HeaderButton
        icon={IconName.Board}
        onClick={this.onHeaderButtonClick}
        onMouseEnter={this.props.setMouseTarget}
        onMouseLeave={this.props.unsetMouseTarget}
        testId={HeaderTestIds.BoardsMenuButton}
      >
        <Media query={ScreenBreakpoints.MediumMin}>
          {(matches: boolean) => (
            <span
              className={classNames(
                styles.boardsButtonText,
                !matches && styles.boardsButtonTextCollapsed,
              )}
            >
              {format('boards')}
            </span>
          )}
        </Media>
      </HeaderButton>
    );
  }
}

class HeaderBoardMenuButtonContainer extends React.Component<AllProps> {
  render() {
    return <HeaderBoardMenuButton {...this.props} />;
  }
}

const mapStateToProps = (state: State): StateProps => {
  const { isBoardsMenuOpen } = getBoardsMenu(state);
  return {
    isBoardsMenuOpen,
    activeOverlays: areAnyPopoversOrOverlaysCurrentlyOpen(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<State>): DispatchProps => {
  return {
    setMouseTarget() {
      dispatch(setBoardsMenuHeaderButtonMouseOver(true));
    },
    unsetMouseTarget() {
      dispatch(setBoardsMenuHeaderButtonMouseOver(false));
    },
    toggleMenu() {
      dispatch(toggleBoardsMenu());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderBoardMenuButtonContainer);
